module.exports = __webpack_public_path__ + "media/images/custom_page/bae173/heros-9ff6a3ea2bd38bd136616e1d93bc8aeb.jpg";